import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { IPerson } from '../../../model/person';
import { IHttpErrorsResponse } from '../../../model/http-errors-response';
import { DireService } from '../../../services/dire.service';
import { InvoicingServiceService } from '../../../services/invoicing-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
import { RechargeDireService } from "../../../services/recharge-dire.service";
import { LoginService } from "../../../services/login.service";

@Component({
  selector: 'app-inv-company-info',
  templateUrl: './inv-company-info.component.html',
  styleUrls: ['./inv-company-info.component.css']
})
export class InvCompanyInfoComponent implements OnInit {

  /**
   * @type {IPerson}
   */
  @Input() person: IPerson;

  /**
   * @type {boolean}
   */
  @Input()  creationMode: boolean = false;

  /**
   * @type {boolean}
   */
  editCompanyInfo: boolean = false;

  /**
   * @type {boolean}
   */
  editAuthorizeds: boolean = false;

  /**
   * @type {boolean}
   */
  toOthers: boolean = false;

  /**
   * @type {string}
   */
  email: string;

  /**
   * @type {IHttpErrorsResponse}
   */
  errors: IHttpErrorsResponse;

  /**
   * Contenido del panel modal para crear una autorización
   */
  @ViewChild('confirmServiceToOthers')
  confirmEditInv: TemplateRef<any>;

  /**
   *
   * @param {LoginService} loginService
   * @param {InvoicingServiceService} invoicingServiceService
   * @param {DireService} direService
   * @param {ToastsManager} toastr
   * @param {NgbModal} modalService
   * @param {TranslateService} translate
   * @param {RechargeDireService} rechargeDireService
   */
  constructor(private loginService: LoginService,
              private invoicingServiceService: InvoicingServiceService,
              private direService: DireService,
              private toastr: ToastsManager,
              private modalService: NgbModal,
              private translate: TranslateService,
              private rechargeDireService: RechargeDireService) {
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    if (this.creationMode) {
      // Creación de invoicing service (solo puede ser con el nif del usuario logueado)
      this.loginService.person$
        .subscribe(person => this.person = person);
    }
  }

  /**
   * Check if the company has services to others
   * @return {string}
   */
  hasServicesToOthers() {
    return this.person['servicesToOthers'];
  }

  /**
   * Abre el panel modal de confirmación de acción
   */
  openConfirmEditInv() {
    this.modalService.open(this.confirmEditInv).result.then((result) => {
      if (result === 'editInv') {
        this.saveInvoicingService();
      }
    });
  }

  /**
   * Save invoicingService
   */
  saveInvoicingService() {
    this.invoicingServiceService.updateInovicingService(this.person)
      .subscribe(() => {
        this.clearState();
      }, error => {
        this.errors = error;
      });
  }

  /**
   * Edit invoicingService data
   */
  editInvoicingService() {
    this.editAuthorizeds = false;
    this.editCompanyInfo = true;
    this.restoreData();
  }

  /**
   * Edit invoicingService data
   */
  editInvoicingAuthorizeds() {
    this.editAuthorizeds = true;
    this.editCompanyInfo = false;
    this.restoreData();
  }

  /**
   * cancelInvoicingService
   */
  cancelInvoicingService() {
    this.clearState();
    this.person['email'] = this.email;
    this.person['servicesToOthers'] = this.toOthers;
  }

  /**
   * restoreData
   */
  restoreData() {
    this.email = this.person['email'];
    this.toOthers = this.person['servicesToOthers'];
  }

  /**
   *
   * @returns {string}
   */
  getClass(): string {
    if (this.editCompanyInfo) {
      return 'editando';
    }
    if (this.editAuthorizeds) {
      return 'editando';
    }
  }

  /**
   *
   * @return {boolean}
   */
  isEditingCompanyInfo(): boolean {
    return !this.creationMode && this.editCompanyInfo;
  }

  /**
   *
   * @return {boolean}
   */
  isEditingAuthorizeds(): boolean {
    return !this.creationMode && this.editAuthorizeds;
  }

  /**
   * Sincroniza el árbol de directorios y los datos de la empresa
   */
  rechargeCompanyInfo() {
    this.synchronizeDire(this.person.code).then(() => {
      if (this.person.identifier === this.loginService.getPerson().identifier){
        // Para el caso en que se sincronice con DIRe la invoicing servie del usuario loguado
        this.loginService.rechargePersonInfo();
      }
      if (!this.creationMode) {
        // Sincronizamos los datos del invoicing service excepto cuando se esta creando una nueva
        this.rechargeInvoicingInfo();
      }
      this.rechargeDireService.setRechargeFromInvoice(true);
    })
  }

  /**
   * Obtiene la información de la empresa
   */
  rechargeInvoicingInfo() {
    this.invoicingServiceService.getInvoicingService(this.person.identifier)
      .subscribe(
        res => {
          this.person = res;
        });
  }

  /**
   * Permite sincronizar el árbol de directorios
   *
   * @param root
   * @returns {Promise<any>}
   */
  synchronizeDire(root): Promise<any> {
    return new Promise<any>(resolve => {
      this.direService.synchronize(root)
        .subscribe(
          () => {
            this.translate.get('inv.companyInfo.synchronizeToast').subscribe((res: string) => {
              this.toastr.info(res).then();
            });
            resolve();
          });
    })
  }

  clearState() {
    this.errors = null;
    this.editCompanyInfo = false;
    this.editAuthorizeds = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-company-info/inv-company-info.component.ts